import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Publish from "@material-ui/icons/Publish";
import Cancel from "@material-ui/icons/Cancel";
import { withStyles } from "@material-ui/core/styles";
import axios from 'axios';

import Button from "@material-ui/core/Button";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

import  api from '../../common/api';

const defaultToolbarSelectStyles = {
  iconButton: {
  },
  iconContainer: {
    marginRight: "24px",
  },
};

class CustomToolbarSelect extends React.Component {
  constructor(props) {
    super(props);
      this.state = {
        open : false,
        dialogOpen: false
    };
  }

  handleClickInverseSelection = () => {
      const indexes = this.props.selectedRows.data;
      const vehicles=[];
      for (const [index, value] of indexes.entries()) {
        vehicles.push({'id':this.props.vehicles[value.dataIndex].id})
      } 
      const token =localStorage.getItem('userToken')
      let request =  JSON.stringify({'matrix_id':this.props.matrixId,'vehicles' : vehicles});
      axios.post(api.authorization_matrix_vehicles,
         request,
         {headers: {'Content-Type': 'application/json',"Authorization" : `Bearer ${token}`}}
         )
        .then((response) => {
            this.setState({dialogOpen: true});
        })
        .catch(function (error) {
            console.log(error);
      })

  };

  handleClickDeselectAll = () => {
    this.props.setSelectedRows([]);
  };

  handleRedirect(){
    window.location.href="/contracts"
  }

  render() {
    const { classes } = this.props;

    return (
           <div className={classes.iconContainer}>
              <Dialog
                open={this.state.dialogOpen}
                fullWidth
                aria-labelledby="responsive-dialog-title"
              >
                <DialogTitle id="responsive-dialog-title">{"Matriz de autorización"}</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                      Vehículos asignados con éxito!
                  </DialogContentText>
                </DialogContent>
                <DialogActions disableSpacing="false">  
                  <Button onClick={this.handleRedirect} variant="contained" color="primary" >
                      Aceptar
                  </Button>
                </DialogActions>
              </Dialog>
         
              <Tooltip title={"Limpiar"}>
                <IconButton className={classes.iconButton} onClick={this.handleClickDeselectAll}>
                  <Cancel className={classes.icon} />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Asignar vehiculos"}>
                <IconButton className={classes.iconButton} onClick={this.handleClickInverseSelection}>
                  <Publish className={[classes.icon, classes.inverseIcon].join(" ")} />
                </IconButton>
              </Tooltip>
            </div>
    );
  }
}

export default withStyles(defaultToolbarSelectStyles, { name: "CustomToolbarSelect" })(CustomToolbarSelect);